import React from 'react';
import PillBtn from './PillBtn';

// Extracted from LessonWorkspace.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior). Teacher-only
// compact pill with live-session start/end, copy-link, and follow-mode
// controls.
export default function LiveSessionPill({
  isStudent,
  otherParticipants,
  isLiveSession,
  studentId,
  lessonId,
  isFollowMode,
  onToggleSession,
  onCopyLink,
  onToggleFollowMode,
}) {
  if (isStudent) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 16,
      right: 16,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      background: 'rgba(255,255,255,0.92)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderRadius: 999,
      boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
      border: '1px solid rgba(0,0,0,0.07)',
      padding: '0 4px',
      height: 36,
      gap: 0,
    }}>
      {/* Presence dot + name */}
      {otherParticipants.length > 0 && (<>
        <div
          title={otherParticipants.map(p => p.name).join(', ') + ' is online'}
          style={{
            display: 'flex', alignItems: 'center', gap: 5,
            padding: '0 10px 0 8px',
            fontSize: 12, fontWeight: 500, color: '#16a34a',
            maxWidth: 110, overflow: 'hidden', whiteSpace: 'nowrap',
          }}
        >
          <span style={{ flexShrink: 0, width: 7, height: 7, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 5px rgba(34,197,94,0.7)' }} />
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{otherParticipants[0].name}</span>
        </div>
        <span style={{ width: 1, height: 18, background: 'rgba(0,0,0,0.1)', flexShrink: 0 }} />
      </>)}

      {/* Start / End */}
      <div data-tour="lesson-start" style={{ display: 'inline-flex' }}>
      <PillBtn
        onClick={onToggleSession}
        title={isLiveSession ? 'End lesson' : 'Start lesson'}
        color={isLiveSession ? '#dc2626' : '#16a34a'}
      >
        {isLiveSession
          ? <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><rect x="4" y="4" width="16" height="16" rx="2"/></svg>
          : <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>
        }
      </PillBtn>
      </div>

      {/* Copy link */}
      {isLiveSession && studentId && lessonId && (<>
        <span style={{ width: 1, height: 18, background: 'rgba(0,0,0,0.08)', flexShrink: 0 }} />
        <PillBtn
          onClick={onCopyLink}
          title="Copy student link"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
          </svg>
        </PillBtn>
      </>)}

      {/* Follow mode */}
      {isLiveSession && (<>
        <span style={{ width: 1, height: 18, background: 'rgba(0,0,0,0.08)', flexShrink: 0 }} />
        <PillBtn
          onClick={onToggleFollowMode}
          title={isFollowMode ? 'Release — student can interact' : 'Follow me — student watches only'}
          color={isFollowMode ? '#ee5a24' : undefined}
        >
          {isFollowMode
            ? <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            : <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 11V7a5 5 0 0 0-10 0v4"/><rect x="3" y="11" width="18" height="11" rx="2"/></svg>
          }
        </PillBtn>
      </>)}
    </div>
  );
}
